import React from "react";
import { useLocation } from "react-router-dom";
import ChatContent from "../../components/chatComponent/ChatContent";
import { Container } from "../../components/common/Container";
import { IPaymentTracking } from "../../interfaces/paymentTracking";
export default function ChatPage() {
  const { state } = useLocation<{
    item: IPaymentTracking
  }>();
  return (
    <Container>
      <ChatContent {...state.item} />
    </Container>
  );
}
